export default __webpack_public_path__ + "static/media/thickblue.8bb9a137.gif";